export default __webpack_public_path__ + "static/media/account-ico-mail.6271110d.svg";